import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  noSignal: {
    color: theme.palette.error.main,
  },
  lowSignal: {
    color: theme.palette.warning.main,
  },
  highSignal: {
    color: theme.palette.success.main,
  },
}));
